<groundworks-modal>
  <groundworks-modal-header
    [title]="'Payment History'"
    [isCancellable]="true"
    (cancelModal)="closeModal()"
  />
  <groundworks-modal-body>
    @if (isLoading()) {
      <groundworks-state-message
        data-testid="loading-state"
        type="loading"
        message="Loading payment history..."
      />
    } @else if (isForbidden()) {
      <groundworks-state-message
        data-testid="forbidden-state"
        type="error"
        message="You do not have permission to view payment history."
      />
    } @else if (hasError()) {
      <groundworks-state-message
        data-testid="error-state"
        type="error"
        message="Payment history could not be loaded. Please try again."
        [button]="retryButton"
      />
    } @else if (entries().length === 0) {
      <groundworks-state-message
        data-testid="empty-state"
        type="no-matches"
        message="No payment history for this job."
      />
    } @else {
      <div class="table-responsive" data-testid="payment-history-table">
        <groundworks-table [data]="tableData()" />
      </div>
    }
  </groundworks-modal-body>
  <groundworks-modal-footer [actions]="footerActions" />
</groundworks-modal>
